module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.5ecbc99.ttf";